import { ClientDto } from '../api/dto'
import { Client } from '../models'

const clientToModelTransformer = (dto: ClientDto): Client => ({
  id: dto.id,
  clientId: dto.clientId,
  name: dto.name,
  description: dto.description ?? null,
  createdAt: dto.createdAt ? new Date(dto.createdAt) : null,
})

export default clientToModelTransformer
